import { A, useParams } from "@solidjs/router";
import { useQuery } from "@tanstack/solid-query";
import { ParentComponent } from "solid-js";

import gqlClient from "../../schema/gqlAuthorizedRequest.js";
import { graphql } from "../../schema/index.js";
import { enumToUcFirstLabel } from "../../utils/enumToLabel.js";
import { BackButton } from "../common/BackButton.js";
import { Layout } from "../common/Layout.js";
import { PageHeader } from "../common/PageHeader.js";
import PropertyDisplay from "../common/PropertyDisplay.js";
import { TabLink } from "../tabs/TabLink.js";
import { Tabs } from "../tabs/Tabs.js";

const getAccessRoleQueryGql = graphql(`
  query getAccessRoleForEditNav($id: Int!) {
    getAccessRole(id: $id) {
      id
      name
      description
    }
  }
`);

export const AccessRoleEditNav: ParentComponent = (props) => {
  const accessRoleId = Number.parseInt(useParams().id, 10);

  const accessRole = useQuery(() => ({
    queryKey: ["accessRole", accessRoleId],
    queryFn: async () =>
      gqlClient.request(getAccessRoleQueryGql, { id: accessRoleId }),
  }));

  return (
    <Layout>
      <BackButton to="/access-control" />
      <PageHeader
        parentTitle={<A href="/access-control">Access Control</A>}
        title={enumToUcFirstLabel(accessRole.data?.getAccessRole.name)}
        class="mb-4"
        subtitle={
          <PropertyDisplay title="Description:">
            {accessRole.data?.getAccessRole.description}
          </PropertyDisplay>
        }
      />
      <div class="w-full overflow-x-auto">
        <Tabs class="gap-3">
          <TabLink href="users" pageTitle="Users" />
          <TabLink href="permissions" pageTitle="Permissions" />
        </Tabs>
      </div>
      <div class="w-full">{props.children}</div>
    </Layout>
  );
};
